<template>
  <div data-aos="fade-up" data-aos-offset="0" class="consultDetail">
    <v-container fluid>
      <v-container fluid>
        <v-row justify="center" align="center">
          <v-col cols="10">
            <v-breadcrumbs :items="breadItems" divider="/"></v-breadcrumbs>
          </v-col>
        </v-row>
      </v-container>
      <DetailContainer :title="item.Title">
        <h3 class="sr-only">{{ item.Title }}</h3>
        <v-container>
          <v-row justify="center">
            <!-- <v-col cols="5" /> -->
            <v-col
              cols="11"
              class="mb-0 d-flex justify-sm-space-around justify-md-space-between align-center flex-wrap"
            >
              <div
                class="ma-1 categoryItem"
                :style="{
                  backgroundColor: SYS.setCategoryBgColor(item.subcategory)
                }"
                style="width:150px"
              >
                {{ SYS.setCategory(item.subcategory) }}
              </div>
              <div v-if="item.important" class="ma-1 importantChip">
                精選
              </div>
              <v-spacer />
              <div class="grey--text">
                公告日期：{{ TOOL.setDateString(item.PublicTime) }}
              </div>
            </v-col>
          </v-row>
          <v-row class="d-flex justify-center white">
            <v-col cols="11">
              <v-divider />
            </v-col>
          </v-row>
          <v-row justify="center" align="center">
            <v-col cols="10">
              <div
                class="content-wrapper"
                v-html="TOOL.replaceUnitToRem(item.Content)"
              />
              <!-- {{ item.Content }} -->
            </v-col>
          </v-row>
          <v-row justify="center" align="center">
            <v-col cols="10">
              <PhotoList :item="item" :topic="item.Title" />
            </v-col>
          </v-row>
        </v-container>
      </DetailContainer>
      <!-- 20240704 Ben說隱藏 :avatarName="item.UserId" -->
      <DetailContainer
        v-for="(item, idx) in answerList"
        :key="idx"
        :loop="true"
        :index="idx"
        title="專家來解答"
        avatarIcon="consult/icon_avatar_pro.svg"
        avatarName="專家回覆"
      >
        <v-container>
          <v-row justify="center" align="center">
            <v-col cols="10">
              <div
                class="content-wrapper"
                v-html="TOOL.replaceUnitToRem(item.Content)"
              />
              <!-- {{ item.Content }} -->
            </v-col>
          </v-row>
          <v-row justify="center" align="center">
            <v-col cols="10">
              <PhotoList :item="item" :topic="item.Title" />
            </v-col>
          </v-row>
        </v-container>
      </DetailContainer>
      <!-- 20240704 Ben說隱藏 -->
      <!-- <v-container fluid class="mt-12">
        <v-row justify="center" align="center" class="my-4">
          <v-col
            class="ct-text-subtitle ct-text-bolder mb-0 d-flex justify-center align-center"
          >
            <span class="card-title" style="display:inline-block">
              您覺得這則答覆
            </span>
          </v-col>
        </v-row>
        <v-row justify="center" align="start">
          <v-col
            cols="4"
            class="d-flex justify-center align-center"
            style="text-align: center;"
          >
            <div
              id="item_like"
              class="item btn mx-4"
              :class="{ active: btnActive == 'item_like' }"
              role="button"
              tabindex="0"
              @keypress="setBtn('item_like')"
              @click="setBtn('item_like')"
            >
              <svg
                preserveAspectRatio="xMidYMid slice"
                width="124"
                height="165"
                viewBox="0 0 124 165"
              >
                <defs>
                  <clipPath id="item_like_clip_c">
                    <rect
                      x="0"
                      width="124"
                      height="165"
                      rx="10"
                      fill="#f9fff2"
                    />
                  </clipPath>
                </defs>
                <g clip-path="url(#item_like_clip_c)">
                  <circle
                    id="item_like_clip"
                    class="clip"
                    cx="-200"
                    cy="-200"
                    fill="#D5FFA4"
                    r="100px"
                  ></circle>
                  <image
                    height="75%"
                    preserveAspectRatio="xMinYMin slice"
                    x="15%"
                    width="70%"
                    :xlink:href="cTitleImg('consult/icon_like.svg')"
                  ></image>
                  <text x="15%" y="140" class="ct-text-subtitle2">
                    {{ "非常實用" }}
                  </text>
                </g>
              </svg>
            </div>
            <div
              id="item_dislike"
              class="item btn mx-4"
              :class="{ active: btnActive == 'item_dislike' }"
              role="button"
              tabindex="0"
              @keypress="setBtn('item_dislike')"
              @click="setBtn('item_dislike')"
            >
              <svg
                preserveAspectRatio="xMidYMid slice"
                width="124"
                height="165"
                viewBox="0 0 124 165"
              >
                <defs>
                  <clipPath id="item_dislike_clip_c">
                    <rect
                      x="0"
                      width="124"
                      height="165"
                      rx="10"
                      fill="#f9fff2"
                    />
                  </clipPath>
                </defs>
                <g clip-path="url(#item_dislike_clip_c)">
                  <circle
                    id="item_dislike_clip"
                    class="clip"
                    cx="-200"
                    cy="-200"
                    fill="#FFCACA"
                    r="100px"
                  ></circle>
                  <image
                    height="75%"
                    preserveAspectRatio="xMinYMin slice"
                    x="15%"
                    width="70%"
                    :xlink:href="cTitleImg('consult/icon_dislike.svg')"
                  ></image>
                  <text x="15%" y="140" class="ct-text-subtitle2">
                    {{ "沒有幫助" }}
                  </text>
                </g>
              </svg>
            </div>
          </v-col>
        </v-row>
      </v-container> -->
      <v-container fluid class="mt-6">
        <v-row class="my-2">
          <v-col class="d-flex justify-center align-center ma-auto">
            <div>
              <span class="ct-text-bolder"
                >*各校老師若需要提問，請至後臺管理系統進行問題新增。</span
              >
            </div>
          </v-col>
        </v-row>
      </v-container>
      <v-container fluid>
        <v-row class="my-3">
          <v-col class="d-flex justify-center align-center ma-auto">
            <ListBack />
          </v-col>
        </v-row>
      </v-container>
    </v-container>
    <Footer />
  </div>
</template>
<script>
import Footer from "@/components/layouts/footer.vue";
import DetailContainer from "@/components/consult/DetailContainer.vue";
import PhotoList from "@/components/ui/detailComponent/PhotoList.vue";
import ListBack from "@/components/ui/detailComponent/ListBack.vue";
import { scrollToTopMixin } from "@/mixins/scrollToTop.js";

export default {
  mixins: [scrollToTopMixin],
  components: {
    Footer,
    DetailContainer,
    PhotoList,
    ListBack
  },
  props: {
    // item: {
    //   type: Object,
    //   default() {
    //     return {
    //       category: 1,
    //       title: "標題",
    //       onlineDate: Date.now(),
    //       content: "內容"
    //     };
    //   }
    // }
  },
  data() {
    return {
      breadItems: [
        {
          text: "植樹專家諮詢平臺",
          disabled: false,
          to: "/Consult/"
        }
        // {
        //   text: "this.item.schoolCounty + this.item.schoolName",
        //   disabled: true,
        //   href: "breadcrumbs_link_2"
        // }
      ],
      item: {
        category: 1,
        title: "標題",
        onlineDate: Date.now(),
        content: "內容"
      },
      answerList: [],
      btmItem: null,
      btnActive: "",
      setPhotoViewer: ""
    };
  },
  watch: {
    item() {
      this.breadItems = [
        {
          text: "植樹專家諮詢平臺",
          disabled: false,
          to: "/Consult/"
        }
      ];
      this.breadItems.push({
        text: this.item.Title,
        disabled: true,
        href: "breadcrumbs_link_1"
      });
      document.title += "-" + this.item.Title;
    }
  },
  mounted() {
    // if (typeof this.$route.params.item !== "undefined") {
    //   this.item = this.$route.params.item;
    // }
    this.getConsultDetail();
    // this.setAnimate("item_like");
    // this.setAnimate("item_dislike");
  },
  computed: {},

  methods: {
    setBtn(val) {
      this.btnActive = val;
    },
    getConsultDetail() {
      return this.axios({
        methods: "get",
        url: `${process.env.VUE_APP_API_URL}api/Consult/GetConsultDetail`,
        params: {
          sno: this.$route.query.idx
        }
      }).then(resp => {
        this.item = resp.data.data;
        if (
          this.item.AnswerList != null &&
          typeof this.item.AnswerList !== "undefined" &&
          this.item.AnswerList.length > 0
        ) {
          this.answerList = this.item.AnswerList;
          //this.photoItem = this.item.photoList[0];
        }
      });
    },
    cTitleImg(val) {
      let path = val;
      return require(`@/assets/images/${path}`);
    },
    setAnimate(id) {
      // const items = []
      const point = document.querySelector("svg").createSVGPoint();

      function getCoordinates(e, svg) {
        point.x = e.clientX;
        point.y = e.clientY;
        return point.matrixTransform(svg.getScreenCTM().inverse());
      }

      // function changeColor(e) {
      //   document.body.className = e.currentTarget.className
      // }

      function Item(config) {
        Object.keys(config).forEach(item => {
          this[item] = config[item];
        }, this);
        this.el.addEventListener("mousemove", this.mouseMoveHandler.bind(this));
        this.el.addEventListener("touchmove", this.touchMoveHandler.bind(this));
        this.el.addEventListener(
          "mouseleave",
          this.mouseLeaveHandler.bind(this)
        );
      }

      Item.prototype = {
        update: function update(c) {
          const d = document.querySelector(this.clip);
          d.setAttribute("cx", c.x);
          d.setAttribute("cy", c.y);
          // this.clip.children[0].setAttribute('cx', c.x)
          // this.clip.children[0].setAttribute('cy', c.y)
        },
        mouseMoveHandler: function mouseMoveHandler(e) {
          this.update(getCoordinates(e, this.svg));
        },
        touchMoveHandler: function touchMoveHandler(e) {
          e.preventDefault();
          const touch = e.targetTouches[0];
          if (touch) return this.update(getCoordinates(touch, this.svg));
        },
        mouseLeaveHandler: function mouseLeaveHandler(e) {
          e.preventDefault();
          this.update({ x: -200, y: -200 });
        }
      };

      const d = document.getElementById(id);
      const temp = new Item({
        el: d,
        svg: d.querySelector("svg"),
        clip: "#" + id + "_clip"
      });
      this.btmItem = temp;
      // ;[].slice
      //   .call(document.querySelectorAll('.' + id), 0)
      //   .forEach((item, index) => {
      //     // eslint-disable-next-line prefer-const
      //     // let d = document.querySelector('#clip-' + index + ' circle')
      //     items.push(
      //       new Item({
      //         el: item,
      //         svg: item.querySelector('svg'),
      //         clip: document.querySelector('#clip-' + index + ' circle')
      //       })
      //     )
      //   })
      // ;[].slice
      //   .call(document.querySelectorAll('button'), 0)
      //   .forEach((button) => {
      //     button.addEventListener('click', changeColor)
      //   })
    }
  }
};
</script>
<style lang="scss" scoped>
.consultDetail {
  background-color: #f6edd9;
}

.btn {
  width: 124px;
  height: 165px;
  background: #f9fff2;
  box-shadow: 0px 4px 4px rgba(171, 171, 171, 0.25);
  border-radius: 10px;
  text-align: center;
  user-select: none;

  &.active {
    &#item_dislike {
      background-color: #ffcaca;
    }
    &#item_like {
      background-color: #d5ffa4;
    }
  }
}
</style>
